// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"b34fe697","699":"da34dbf7"}[chunkId] + ".chunk.js";
};